import PropTypes from 'prop-types';

import { DatePicker as DatePickerMui } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

const DatePicker = (props) => {
	const { label, error, helperText, ...rest } = props;

	const inputNode = (
		<DatePickerMui
			sx={{
				' .MuiInputBase-root fieldset': {
					borderColor: error ? 'error.main' : undefined,
				},
			}}
			{...rest}
		/>
	);

	return (
		<Stack spacing={1}>
			{label && <InputLabel>{label}</InputLabel>}
			<FormControl>
				{inputNode}
				{typeof error === 'string' && (
					<FormHelperText error>{error}</FormHelperText>
				)}
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
			</FormControl>
		</Stack>
	);
};

DatePicker.propTypes = {
	...DatePickerMui.propTypes,
	label: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	helperText: PropTypes.string,
};
export default DatePicker;
